import { NgFor, NgIf, isPlatformBrowser } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { IconShareComponent } from "@src/app/components/svg/icon-share/icon-share.component";
import { Comentario } from "@src/app/models/interfaces/comentario.interface";
import { ComentariosService } from "@src/app/servicios/comentarios/comentarios.service";
import { CookieService } from "ngx-cookie-service";
import { first, firstValueFrom } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { environment } from "../../../environments/environment";
import { CommentComponent } from "./commentary/comment.component";
import { SendCommentTextareaComponent } from "./send-comment-textarea/send-comment-textarea.component";

@Component({
  selector: "app-comentarios",
  templateUrl: "./commentary-box.component.html",
  styleUrls: ["./commentary-box.component.scss"],
  imports: [FormsModule, ReactiveFormsModule, MatPaginatorModule, ReactiveFormsModule, CommentComponent, SendCommentTextareaComponent, NgIf, NgFor, IconShareComponent],
  providers: [ComentariosService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentaryBoxComponent implements OnInit, AfterViewInit {
  selectorName: any;
  configBloque: any;
  showBloque: any;
  numComentarios: number = 0;
  showTitulo: any;
  showBtnEnvio: any;
  showTextarea: any;
  showComentarios: any;
  comentariosAnonimos: boolean;
  anonId: any;
  showNombre: any;
  showFecha: any;
  showLogin: any;
  placeholder: any;
  textoBtnEnvio: any;
  notaInformativa: any;
  userId;

  _idVideo: any;
  @Input()
  set idVideo(value) {
    if (!value) return;
    this._idVideo = value;
    this.getComentarios();
  }

  get idVideo() {
    return this._idVideo;
  }
  @Input() noticia?;
  @Input() showRss? = false;
  comentarios: Comentario[] = [];
  comentariosPaginados: Comentario[] = [];
  login = false;
  shake = false;
  dialogRefRegister;
  dialogRefLogin;

  comentarioForm: FormGroup;
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild("textarea") textarea: ElementRef;
  numeroComentariosPagina: number = 10;
  showFirstLastButtons: boolean = false;
  pageSizeOptions: any;
  rrssVisible = false;

  constructor(
    private comentariosService: ComentariosService,
    private cookieService: CookieService,
    @Inject(FormBuilder) private formBuilder: FormBuilder,
    private configService: ConfigService,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID)
    private platformId,
  ) {
    this.comentarioForm = this.formBuilder.group({
      comentario: ["", { validators: [Validators.required, Validators.minLength(3), Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)] }],
    });

    if (this.cookieService.get("userLogin" + environment.name)) {
      this.login = true;
      this.userId = JSON.parse(this.cookieService.get("userLogin" + environment.name)).id;
    }
  }

  ngOnInit(): void {
    this.selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((resultConfig) => {
        if (resultConfig) {
          this.configBloque = resultConfig.noticia[this.selectorName];
          this.showBloque = this.configBloque.bloque_activo === "true";
          if (this.showBloque) {
            // this.numeroComentariosPagina = this.configBloque.comentarios_pagina;
            this.numeroComentariosPagina = 5;
            this.pageSizeOptions = [5, 10, 20, 50, 100];
            // this.pageSizeOptions = this.configBloque.page_size_options.split(',').map(Number);
            // this.initRoutingSubscription();

            this.showTextarea = this.configBloque.mostrar_textarea === "true";
            this.showTitulo = this.configBloque.mostrar_titulo === "true";
            this.showComentarios = this.configBloque.mostrar_comentarios === "true";
            this.comentariosAnonimos = this.configBloque.comentarios_anonimos === "true";
            if (this.configBloque?.id_usuario_anonimo) this.anonId = this.configBloque?.id_usuario_anonimo;

            this.showComentarios = this.configBloque.mostrar_comentarios === "true";
            this.showNombre = this.configBloque.mostrar_nombre_usuario === "true";
            this.showFecha = this.configBloque.mostrar_fecha === "true";

            const colorTituloComentarios = this.configBloque.color_titulo;
            this.elementRef.nativeElement.style.setProperty("--color-titulo-comentarios", colorTituloComentarios);

            this.showLogin = true; //TODO: Implementar lógica para mostrar u ocultar el botón de login
          }
        }
        this.cdr.markForCheck();
      });
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.traducirPaginator();
      this.cdr.markForCheck();
    }
  }

  mostrarRRSS(): void {
    this.rrssVisible = !this.rrssVisible;
  }

  /**
   * Recupera los comentarios de la noticia, los pagina y traduce la paginación si se ejecuta en una plataforma de navegador.
   * @param {Number} [userId] - Se utiliza para especificar el ID de usuario para el cual se recuperan los comentarios.
   * Este parámetro permite que la función recupere los comentarios con los votos previamente realizados por el usuario.
   */
  getComentarios(): void {
    this.numComentarios = 0;
    this.comentarios = [];
    this.comentariosPaginados = [];
    this.showFirstLastButtons = false;

    Promise.all([this.getComentariosPrensa(), this.getComentariosUsuario()]).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.traducirPaginator();
      }
      this.cdr.detectChanges();
    });
  }

  private async getComentariosPrensa(): Promise<void> {
    const commentsPrensa = this.comentariosService.getComentariosPrensa(this._idVideo);
    if (commentsPrensa) {
      const result = await firstValueFrom(commentsPrensa);
      if (result) {
        this.numComentarios = (result ?? []).length;
      }
    }
  }

  private async getComentariosUsuario(): Promise<void> {
    const comments = this.comentariosService.getComentarios(this._idVideo, this.userId);
    if (comments) {
      const result = await firstValueFrom(comments);
      if (result) {
        this.comentarios = result;
        this.actualizarPaginacion();
      }
    }
  }

  private actualizarPaginacion(): void {
    if (!this.comentarios?.length) return;

    // Calcular comentarios paginados
    const startIndex = 0;
    const endIndex = this.numeroComentariosPagina;
    this.comentariosPaginados = this.comentarios.slice(startIndex, endIndex);

    // Actualizar estado de botones de paginación
    if (this.paginator) {
      this.showFirstLastButtons = this.paginator.getNumberOfPages() > 2;
    }

    // Marcar para detección de cambios
    this.cdr.markForCheck(); // Usar markForCheck en lugar de detectChanges
  }

  /**
   * Traduce las etiquetas del componente paginador al español.
   */
  traducirPaginator(): void {
    if (this.paginator) {
      this.paginator._intl.itemsPerPageLabel = "Comentarios por página:";
      this.paginator._intl.nextPageLabel = "Página siguiente";
      this.paginator._intl.previousPageLabel = "Página anterior";
      this.paginator._intl.lastPageLabel = "Última página";
      this.paginator._intl.firstPageLabel = "Primera página";

      const defaultGetRangeLabel = this.paginator._intl.getRangeLabel.bind(this.paginator._intl);
      this.paginator._intl.getRangeLabel = (page, pageSize, length) => {
        return defaultGetRangeLabel(page, pageSize, length).replace("of", "de");
      };
    }
  }

  /**
   * Toma un PageEvent como entrada y pagina la lista de comentarios en consecuencia,
   * determinando también si se muestran los botones de primera y última página según el
   * número total de páginas.
   * @param {PageEvent} event - Contiene información sobre el índice de página y el tamaño
   * de página del componente de paginación.
   */
  cambiarPagina(event: PageEvent): void {
    const startIndex = event.pageIndex * event.pageSize;
    const endIndex = startIndex + event.pageSize;
    this.comentariosPaginados = this.comentarios?.slice(startIndex, endIndex);
    this.showFirstLastButtons = false;
    if (this.paginator.getNumberOfPages() > 2) {
      this.showFirstLastButtons = true;
    }
  }

  /**
   * Inserta un nuevo comentario en la matriz de comentarios y lo ordena por puntuación.
   * Una vez insertado, se recalcula la lista de comentarios paginados.
   *
   * @param event - Representa el comentario a agregar a la lista de comentarios.
   */
  onSendComment(event) {
    const newComment = event;
    const insertIndex = this.comentarios?.findIndex((comment) => Number(comment.score) === 0);
    if (insertIndex === -1) {
      this.comentarios.push(newComment);
    } else {
      this.comentarios?.splice(insertIndex, 0, newComment);
    }
    this.comentariosPaginados = this.comentarios?.slice(0, this.numeroComentariosPagina);
  }

  openLoginDialog(): void {
    if (this.dialogRefLogin) return;
    console.log("openLoginDialog");
    if (this.dialogRefRegister) this.dialogRefRegister.close();
    import("../modal-login/modal-login.component").then(({ ModalLoginComponent }) => {
      this.dialogRefLogin = this.dialog.open(ModalLoginComponent, {
        panelClass: "modal-login",
      });
      this.dialogRefLogin.afterClosed().subscribe(() => {
        this.dialogRefLogin = undefined;
      });
    });
  }

  openRegistroDialog(): void {
    if (this.dialogRefRegister) return;
    if (this.dialogRefLogin) this.dialogRefLogin.close();
    import("../modal-registro/modal-registro.component").then(({ ModalRegistroComponent }) => {
      this.dialogRefRegister = this.dialog.open(ModalRegistroComponent, {
        panelClass: "modal-register",
      });
      this.dialogRefRegister.afterClosed().subscribe(() => {
        this.dialogRefRegister = undefined;
      });
    });
  }

  trackByComentario(index: number, comentario: Comentario): string {
    return comentario?.id;
  }
}
